/**
 * Pager component for tables data.
 * Use example:
 *  <table-pager
 *       total-items="params.series.summary.total_rows_count"
 *       items-per-page="params.series.count"
 *       page="params.series.page"
 *       change-pager="onChangeSeriesPager()" >
 *   </table-pager
 */

angular.module('app').directive('tablePager', TablePager);

// Directive
TablePager.$inject = ['$timeout'];

function TablePager($timeout) {
  return {
    restrict: 'E',
    scope: {
      totalItems: '=',
      itemsPerPage: '=',
      page: '=',
      changePager: '&',
      pagerLengths: '='
    },
    templateUrl: 'app/components/table-pager.html',

    link: function($scope) {
      // debug: console.info('TablePager init', $scope);
      $scope._pagerLengths = $scope.pagerLengths || [10, 20, 50, 100, 200];

      $scope.getTotalPages = function() {
        return Math.ceil($scope.totalItems / $scope.itemsPerPage);
      };

      $scope.update = function() {
        // debug: console.info('TablePager update', $scope);
        $scope.changePager();
      };

      $scope.selectCount = function(count) {
        $scope.page = 1;
        $scope.itemsPerPage = count;
        $timeout($scope.update);
      };

      $scope.selectPage = function(p) {
        $scope.page = p;
        $timeout($scope.update);
      };
    }
  };
}